var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"AboutNavigation"},[_c('ul',_vm._l((_vm.items),function(item){return _c('li',{key:item.name},[_c('router-link',{class:{ 'is-active': _vm.$route.name === item.name },attrs:{"to":{ name: item.name }},domProps:{"textContent":_vm._s(item.title)}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }